module.exports = __webpack_public_path__ + "static/images/f4c0ce54601fefbce16578d63a049dfa.svg";